import { environment } from '@environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { map, catchError } from 'rxjs/operators';
import { C3AuthService } from "@c3library/services/auth/auth.service";

export abstract class BaseService
{
    protected apiBaseUrl: string = "";
    protected apiSegmentUrl: string = "";
    public RETRY_CEILING: number = 0;

    constructor(private currentHttp: HttpClient, private currentRouter: Router, private currentAuthService: C3AuthService | null) {
        this.apiBaseUrl = environment.apiBaseUrl;
    }

    errorHandler(error: any) {

        var errorMessage;
        if (error.error instanceof ErrorEvent) {
            errorMessage = { errorcode: 0, message: error.error.message };
        } else {
            if (error.headers.get('Token-Expired') === "true") {
                console.log("errorHandler::TOKEN EXPIRED");
            }

            const backendMessage = typeof error.error === 'string' && error.error.trim() ? error.error : error.error?.message;
            errorMessage = { errorcode: error.status, message: backendMessage || error.message, error: error.error };
        }
        
        return throwError(errorMessage);
    }

    public getBaseUrl(): string {
        let fullURL: string = this.apiBaseUrl;

        if (this.apiSegmentUrl != null) {
            if (this.apiSegmentUrl.charAt(0) != '/') {
                fullURL += "/";
            }
            fullURL += this.apiSegmentUrl;
        }

        return fullURL;
    }

    public tokenCheckAndRefresh(error: any): Observable<boolean> {
        if (error.headers.get('Token-Expired') === "true") {
            if (!environment.production)
                console.log("tokenCheckAndRefresh::TOKEN EXPIRED");
            if (this.currentAuthService?.currentUserValue != undefined) {
                return this.currentAuthService.refreshToken(this.currentAuthService?.currentUserValue)
                    .pipe(
                        map(n => {
                            // successful refresh
                            return true;
                        }),
                        catchError(this.errorHandler)
                    );
            }
            return throwError(error);
        }
        return throwError(error);
    }

}
